import isEqual from "lodash/isEqual";
import uniq from "lodash/uniq";
import without from "lodash/without";
import React, { useState } from 'react';
import useClickPast from "../../hooks/useClickPast";
import useFilter from '../../hooks/useFilter';
import Button from "../core/Button";
import Checkbox from "../core/Checkbox";
import Dropdown from "../core/Dropdown";
import EmptyTable from '../core/EmptyTable';
import Table from "../core/Table";
import Preloader from "../Preloader";
import EmployeesFilterForm from '../Public/markup/EmployeesFilterForm';
import { MenuNavPeoplesIcon, SfFilterMenuIcon, CabinetTreeActionEditIcon, CabinetTreeActionAddIcon, CabinetTreeActionDeleteIcon, SfFilterCopyIcon } from "../Public/markup/icons";
import './style.scss';
import request from "../../api";
import { standartErrorToast, standartSuccessToast } from "../toasts";
import SubmitButton from "../SubmitButton";
import useObjectState from "../../hooks/useObjectState";
import useApi from "../../hooks/useApi";
import { toFormData } from "../../utils";
import LoadMoreSpinner from "../LoadMoreSpinner";
import useModalWithData from "../../hooks/useModalWithData";
import { SubdivisionModal, UserInfoModal } from "../../pages/Tree";
import PanModal from "../core/PanModal";
import Modal from "../core/Modal";
import useCompanyRole from "../../hooks/useCompanyRole";


export const ActionButtons = ({ onClickLeft, onClickRight, addComponents = [] }) => {
  return <div style={{ display: "flex", justifyContent: "space-evenly", width: "100%" }}>
    <svg
      onClick={onClickLeft}
      width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 11.4L9.89474 17L20 7" stroke="#2CBA2E" stroke-linecap="round" /></svg>
    <svg
      onClick={onClickRight}
      width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 7L12 12L17 7" stroke="#EF372E" stroke-linecap="round" /><path d="M7 17L12 12L17 17" stroke="#EF372E" stroke-linecap="round" /></svg>
    {addComponents}
  </div>
}

const ActionList = ({ agent, sendPassword, setActive, openUserModal, deleteAgent }) => {
  const [isActive, setIsActive] = useState(false)
  const node = useClickPast(() => { setIsActive(false) });

  return (
    <>
      <span className="crm-table__sf-opencontrols" onClick={() => { setIsActive(!isActive) }}>
        <SfFilterMenuIcon />
      </span>
      <ul className={`${isActive ? 'crm-table__sf-controls active' : 'crm-table__sf-controls'}`} ref={node} onClick={() => { setIsActive(!isActive) }}>

        <li onClick={openUserModal}>
          <CabinetTreeActionEditIcon />
          <span>Редактировать</span>
        </li>
        <li onClick={sendPassword}>
          <SfFilterCopyIcon />
          <span>Отправить пароль</span>
        </li>

        {agent?.active !== "Y" && <li onClick={setActive}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 11.4L9.89474 17L20 7" stroke="#2C2E3E" stroke-linecap="round" /></svg>
          <span>Включить аккаунт</span>
        </li>}
        {agent?.active === "Y" && <li onClick={setActive}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 7L12 12L17 7" stroke="#2C2E3E" stroke-linecap="round" /><path d="M7 17L12 12L17 17" stroke="#2C2E3E" stroke-linecap="round" /></svg>
          <span>Отключить аккаунт</span>
        </li>}
        <li onClick={deleteAgent}>
          <CabinetTreeActionDeleteIcon />
          <span>Удалить</span>
        </li>
      </ul>
    </>
  )
}

const CompanyEmployers = () => {

  const isReadOnly = useCompanyRole(["full_access_departament"]);

  const { data: { company }, isLoading: isLoadingCompany, send, isSending } = useApi({
    payload: ["panpartner:company.ajax", "getMyCompany", { isGetFilter: 1 }]
  })

  const {
    handleFilter,
    isLoading,
    filter,
    data: {
      filter: filterData = {},
      employees = [],
      access_list = [],
      access_edit_departament,
      full_acess_company,
      full_acess_department,
      user_departament
    },
    setFilterAndExclude,
    filterBadges,
    removeBadge,
    resetFilter,

    dataSetter

  } = useFilter({
    apiConfig: {
      component: 'panpartner:company.ajax',
      submitFunction: 'getCompanyEmployees',
    },
    defaultFilter: {
    },
    defaultParams: {
    },
    shadowFilters: ['blockId', 'status'],
    fields: {
      parkingType: [],
      prices: {},
      status: [],
      features: []
    },
    isGetFilter: true,
    refreshWhenFilterChange: true,
    processData: (resp, prev) => {
      if (prev.filter) delete resp.filter;
      return { ...prev, ...resp };
    },
    beforeRefresh: (form) => {

      const status = form.get("filter[status][]")
      if (!status) return form
      form.delete("filter[status][]")
      form.append("filter[status]", status)
    }
  });

  const sendPassword = (agentId) => {
    send(["panpartner:agents.ajax", "resetAgentPassword", { agentId }]).then(standartSuccessToast, standartErrorToast)
  }
  const deleteEmployee = agentId => {
    dataSetter('employees', (prev) => {
      const tmp = [...prev];
      const index = tmp.findIndex((item) => item.id === agentId);
      delete tmp[index]
      return tmp;
    })
  }
  
  const firstEmployer = employees?.[0]

  const removeAgent = empl => {
    send(["panpartner:agents.ajax", "removeAgent", empl]).then(r => {
      deleteEmployee(empl.id)
      standartSuccessToast(r)
    }, standartErrorToast)
  }
  const {
    openModal: openDeleteConfirmModal,
  } = useModalWithData({
    content: ({ closeModal, id, fullName, targetDealId, setValue, targetClientId }) => <Modal
      withoutBG
      classes="crm-table__sf-controlsmodal crm-table__sf-controlsmodal_fixation crm-table__sf-controlsmodal_fixation-tree"
      closeByPastClick
      close={closeModal}
    >

      <div style={{ width: 500, padding: "30px 65px" }}>
        <div className="crm-table__sf-controlsmodaltitle">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="8.5" stroke="#EF372E" /><line x1="12.0435" y1="7.5" x2="12.0435" y2="13.5" stroke="#EF372E" stroke-linecap="round" /><circle cx="12.0435" cy="15.5" r="0.5" fill="#EF372E" /></svg>
          Удалить учетную запись сотрудника?
        </div>
        <div className="crm-table__sf-controlsmodaltext">
          Без возможности восстановления данных
        </div>

        <div style={{ marginTop: 20, marginBottom: 10 }}>Назначить ответственного за клиентов и фиксации <span style={{ fontWeight: 700 }}>{fullName}</span></div>

        <Dropdown
          value={targetClientId}
          options={employees.filter(d => d.id !== id)}
          onChange={v => setValue("targetClientId", v)}
          titleKey="fullName"

        />

        <div style={{ marginTop: 20, marginBottom: 10 }}>Назначить ответственного за сделки <span style={{ fontWeight: 700 }}>{fullName}</span></div>

        <Dropdown
          value={targetDealId}
          options={employees.filter(d => d.id !== id)}
          onChange={v => setValue("targetDealId", v)}
          titleKey="fullName"

        />
        <div className="crm-table__sf-controlsmodalbtns">
          <Button buttonType="line" onClick={closeModal}>Отменить</Button>
          <Button
            buttonType="primary"
            onClick={() => {
              closeModal()
              removeAgent({ id, targetClientId: targetClientId?? firstEmployer.id, targetDealId: targetDealId?? firstEmployer.id })
            }}
          >
            Удалить
          </Button>
        </div>
      </div>
    </Modal>,
    modalProps: {
      withoutBG: true,
      closeByPastClick: true,
      classes: "crm-table__sf-controlsmodal crm-table__sf-controlsmodal_compilation",
    },
    dep: [employees]
  })

  const setEmployerValues = (employeerId, values) => {
    dataSetter('employees', (prev) => {
      const tmp = [...prev];
      const index = tmp.findIndex((item) => item.id === employeerId);
      tmp[index] = { ...tmp[index], ...(typeof values === "function" ? values(tmp[index]) : values) };
      return tmp;
    })
  }

  const handleEditEmploye = (employeeValues = {}) => {
    const params = {
      employeeId: employeeValues?.id,
      departmentId: employeeValues?.departmentId,
      departamentId: employeeValues?.departmentId,
      position: employeeValues?.position, //director || agent уточнить, есть ущё post у пользователя
      comment: employeeValues?.comment || "",
      access: employeeValues?.access,
      departament: departments.find(({ id }) => id === employeeValues?.departmentId)
    }

    setEmployerValues(employeeValues.id, prev=>({...prev, ...employeeValues, ...params, access: employeeValues.access_list.find(({value}) => value === employeeValues?.access)}))

    if(params.departament?.employees) delete params.departament.employees;

    if(params.departament?.generalDirector) delete params.departament.generalDirector;

    send(['panpartner:company.ajax', "editEmployee", toFormData(params)]).then(standartSuccessToast, standartErrorToast)

    closeUserInfoModal()
  }
  
  const getEmployee = params => {
    return send(['panpartner:company.ajax', "getEmployee", params]).then(resp => {
      if (resp.access_list) dataSetter("access_list", resp.access_list)
      return Promise.resolve({ resp })
    }, standartErrorToast)
  }

  const {
    openModal: openUserInfoModal,
    closeModal: closeUserInfoModal
  } = useModalWithData({
    content: ({ closeModal, user, userDepartment }) => <PanModal customClass="tree-modal" isSmall title={'Информация о сотруднике'} closeModal={closeModal}>
      <UserInfoModal
        user={user}
        userDepartment={userDepartment}
        departments={departments}
        getEmployee={getEmployee}
        access_list={access_list}
        handleSave={handleEditEmploye}
        closeModal={closeModal}
      />
    </PanModal>,
    modalProps: {
      withoutBG: true,
      closeByPastClick: true,
      classes: "crm-table__sf-controlsmodal crm-table__sf-controlsmodal_compilation",
    },
    dep: [company,]
  })

  const toggleActive = agent => {

    const active = agent.active === "Y" ? "N" : "Y";

    send(["panpartner:agents.ajax", "setActive", { agentId: agent.id, active }])
      .then(r => {
        dataSetter("employees", prev => {

          const tmpIndex = prev.findIndex(v => v.id === agent.id);

          const tmp = [...prev];

          tmp[tmpIndex].active = tmp.active === "Y" ? "N" : "Y";

          return tmp;

        })
        standartSuccessToast(r)
      }, standartErrorToast)
  }


  const { state, setValue, setValues, reset } = useObjectState({
    loadingManyEmpl: false
  })

  const editManyEmployees = () => {
    setValue("loadingManyEmpl", true)
    const params = toFormData({
      employeeIds: selectedObjects,
      departmentId: state.departmentId,
      access: state.access
    })
    request("panpartner:company.ajax", "editManyEmployees", params)
      .then(r => {
        standartSuccessToast(r)
      }, standartErrorToast)
      .finally(() => setValue("loadingManyEmpl", false))
  }

  const [selectedObjects, setSelectedObjects] = useState([]);
  const selectItems = id => setSelectedObjects(prev => uniq(prev.concat(id)))
  const deselectItems = id => setSelectedObjects(prev => without(prev, ...(Array.isArray(id) ? id : [id])))
  const toggleItems = (id, checked) => checked ? selectItems(id) : deselectItems(id)

  const getColumns = () => [
    {
      title: () => {
        const allIds = employees.map(item => item.id)?.sort()
        const checked = isEqual(allIds, [...selectedObjects].sort())
        return <Checkbox
          id={'all'}
          view="invert"
          checked={checked}
          onChange={e => toggleItems(allIds, e.target.checked)}
        />
      },
      dataIndex: 'id',
      key: 'id',
      width: 50,
      render: (id) => (
        <Checkbox
          id={id}
          view="invert"
          checked={selectedObjects.includes(id)}
          onChange={e => toggleItems(id, e.target.checked)}
        />
      ),
    },
    {
      title: "Сотрудник",
      dataIndex: "fullName",
      key: "fullName",
      render: (fullName, { phone, email }) =>
        <div>
          <div><b>{fullName}</b></div>
          <div>{phone}</div>
          <div>{email}</div>
        </div>
    },
    {
      title: "Должность",
      dataIndex: "position",
      key: "position",
      render: (position) =>
        <p>
          {position}
        </p>
    },
    {
      title: "Отдел",
      dataIndex: "departament",
      key: "departament",
      render: (departament) =>
        <p>
          {departament.name}
        </p>
    },
    {
      title: "Доступ",
      dataIndex: "access",
      key: "access",
      render: (access) =>
        <p>
          {access?.title}
        </p>
    },
    {
      title: "Последняя авторизация",
      dataIndex: "lastLogin",
      key: "lastLogin",
      render: (lastLogin) =>
        <p>
          {lastLogin}
        </p>
    },
   ...(isReadOnly? []: [{
      title: "Действия",
      dataIndex: "lastView",
      key: "lastView",

      render: (text, record, isActive) => {
        return (
          <div className="crm-table__sf-action">
            {/*<SfControls links={record.links} city={record.city} url={record.url} type={record.filterType} userId={record.client?.agentId} xmlId={record.xmlId}/>*/}
            <ActionList
              sendPassword={() => sendPassword(record.id)}
              setActive={() => toggleActive(record)}
              agent={record}
              openUserModal={() => openUserInfoModal({ user: record, userDepartment: record.departament })}
              deleteAgent={() => openDeleteConfirmModal(record)}
            />

          </div>
        )
      },
    }]),

  ]

  if (isLoading) return <Preloader loading />;

  const departments = company?.departments

  return (
    <div className="company-employers crm-table crm-table_filters">

      <EmployeesFilterForm
        filterData={filterData}
        filter={filter}
        setFilterAndExclude={setFilterAndExclude}
        handleFilter={handleFilter}
        isLoading={isLoading}
      />
      <Table
        rowKey="id"
        showSorterTooltip={false}
        columns={getColumns()}
        dataSource={employees}
        pagination={false}
        locale={{ emptyText: "ничего не найдено" }}
        customPagination={true}
      />

      <div className="company-employers__actions">
        <div>
          <label className="hp__form-label text">
            <span>Назначить отдел</span>
          </label>

          {!!departments?.length && <Dropdown
            options={departments}
            customHandler={v => setValue("departmentId", v.id)}
            placeholder="Выбрать"
            wrapperClass=""
            titleKey="name"
            value={state.departmentId}
          />}
        </div>

        <div className="">
          <label className="hp__form-label text">
            <span>Доступ</span>
          </label>
          <Dropdown
            options={access_list}
            customHandler={v => setValue("access", v.value)}
            placeholder="Выбрать"
            wrapperClass=""
            valueKey="value"
            value={state.access}
          />
        </div>

        <div className="company-employers__actions-btns">
          <SubmitButton buttonType="primary_gray" type="button" onClick={() => editManyEmployees()} isLoading={state.loadingManyEmpl}>
            Применить
          </SubmitButton>
        </div>
        {/* <div className="company-employers__actions-btns">
          <Button buttonType="line">Отменить</Button>
        </div> */}
      </div>
    </div>
  )
}

export default CompanyEmployers
